<ng-container *ngIf="{ mobile: mobileLayout$ | async, editing: isEditing$ | async } as layout">
  <mat-card [class.editing]="layout.editing">
    <mat-card-content [ngSwitch]="activityTypeSelected" [class.editing]="layout.editing" class="card-content">
      <ng-container [ngTemplateOutlet]="avatar"></ng-container>
      <!-- Note -->
      <crm-activity-logger-note
        *ngSwitchCase="'Note'"
        class="activity-content"
        [activity]="activity$ | async"
        [mobile]="layout.mobile"
        [(description)]="sharedDescription"
      >
        <ng-container *ngTemplateOutlet="activitySelector" crmLoggerContent="after-description"></ng-container>
        <ng-container crmLoggerContent="fields">
          <ng-container *ngTemplateOutlet="associationFormRow"></ng-container>
          <glxy-form-row class="detail-form-row" [class.mobile]="layout.mobile">
            <ng-container [ngTemplateOutlet]="addTeamMembers"></ng-container>
          </glxy-form-row>
          <glxy-form-row class="detail-form-row" [class.mobile]="layout.mobile">
            <ng-container [ngTemplateOutlet]="addOpportunities"></ng-container>
          </glxy-form-row>
          <glxy-form-row class="detail-form-row" [class.mobile]="layout.mobile">
            <ng-container [ngTemplateOutlet]="addTags"></ng-container>
          </glxy-form-row>
          <ng-container [ngTemplateOutlet]="addFollowUpTask"></ng-container>
        </ng-container>
      </crm-activity-logger-note>
      <!-- Email -->
      <crm-activity-logger-email
        *ngSwitchCase="'Email'"
        class="activity-content"
        [activity]="activity$ | async"
        [mobile]="layout.mobile"
        [(description)]="sharedDescription"
      >
        <ng-container *ngTemplateOutlet="activitySelector" crmLoggerContent="after-description"></ng-container>
        <ng-container crmLoggerContent="fields">
          <ng-container *ngTemplateOutlet="associationFormRow"></ng-container>
          <glxy-form-row class="detail-form-row" [class.mobile]="layout.mobile">
            <ng-container [ngTemplateOutlet]="addTeamMembers"></ng-container>
          </glxy-form-row>
          <glxy-form-row class="detail-form-row" [class.mobile]="layout.mobile">
            <ng-container [ngTemplateOutlet]="addOpportunities"></ng-container>
          </glxy-form-row>
          <glxy-form-row class="detail-form-row" [class.mobile]="layout.mobile">
            <ng-container [ngTemplateOutlet]="addTags"></ng-container>
          </glxy-form-row>
          <ng-container [ngTemplateOutlet]="addFollowUpTask"></ng-container>
        </ng-container>
      </crm-activity-logger-email>
      <!-- Call -->
      <crm-activity-logger-call
        *ngSwitchCase="'Call'"
        class="activity-content"
        [activity]="activity$ | async"
        [mobile]="layout.mobile"
        [(description)]="sharedDescription"
      >
        <ng-container *ngTemplateOutlet="activitySelector" crmLoggerContent="after-description"></ng-container>
        <ng-container crmLoggerContent="fields">
          <ng-container *ngTemplateOutlet="associationFormRow"></ng-container>
          <glxy-form-row class="detail-form-row" [class.mobile]="layout.mobile">
            <ng-container [ngTemplateOutlet]="addTeamMembers"></ng-container>
          </glxy-form-row>
          <glxy-form-row class="detail-form-row" [class.mobile]="layout.mobile">
            <ng-container [ngTemplateOutlet]="addOpportunities"></ng-container>
          </glxy-form-row>
          <glxy-form-row class="detail-form-row" [class.mobile]="layout.mobile">
            <ng-container [ngTemplateOutlet]="addTags"></ng-container>
          </glxy-form-row>
          <ng-container [ngTemplateOutlet]="addFollowUpTask"></ng-container>
        </ng-container>
      </crm-activity-logger-call>
      <!-- Meeting -->
      <crm-activity-logger-meeting
        *ngSwitchCase="'Meeting'"
        class="activity-content"
        [activity]="activity$ | async"
        [mobile]="layout.mobile"
        [(description)]="sharedDescription"
      >
        <ng-container *ngTemplateOutlet="activitySelector" crmLoggerContent="after-description"></ng-container>
        <ng-container crmLoggerContent="fields">
          <ng-container *ngTemplateOutlet="associationFormRow"></ng-container>
          <glxy-form-row class="detail-form-row" [class.mobile]="layout.mobile">
            <ng-container [ngTemplateOutlet]="addTeamMembers"></ng-container>
          </glxy-form-row>
          <glxy-form-row class="detail-form-row" [class.mobile]="layout.mobile">
            <ng-container [ngTemplateOutlet]="addOpportunities"></ng-container>
          </glxy-form-row>
          <glxy-form-row class="detail-form-row" [class.mobile]="layout.mobile">
            <ng-container [ngTemplateOutlet]="addTags"></ng-container>
          </glxy-form-row>
          <ng-container [ngTemplateOutlet]="addFollowUpTask"></ng-container>
        </ng-container>
      </crm-activity-logger-meeting>
      <!-- Task -->
      <crm-activity-logger-task
        *ngSwitchCase="'Task'"
        class="activity-content"
        [activity]="activity$ | async"
        [activityOwner]="activityOwner"
        [mobile]="layout.mobile"
        [user]="user$ | async"
        [(description)]="sharedDescription"
      >
        <ng-container *ngTemplateOutlet="activitySelector" crmLoggerContent="after-description"></ng-container>
        <ng-container crmLoggerContent="fields">
          <ng-container *ngTemplateOutlet="associationFormRow"></ng-container>
          <glxy-form-row class="detail-form-row" [class.mobile]="layout.mobile">
            <ng-container [ngTemplateOutlet]="addOpportunities"></ng-container>
          </glxy-form-row>
          <glxy-form-row class="detail-form-row" [class.mobile]="layout.mobile">
            <ng-container [ngTemplateOutlet]="addTags"></ng-container>
          </glxy-form-row>
        </ng-container>
      </crm-activity-logger-task>
      <!-- Communication -->
      <crm-activity-logger-communication
        *ngSwitchCase="'Communication'"
        class="activity-content"
        [activity]="activity$ | async"
        [mobile]="layout.mobile"
        [communicationType]="communicationSubTypeSelected"
        [(description)]="sharedDescription"
      >
        <ng-container *ngTemplateOutlet="activitySelector" crmLoggerContent="after-description"></ng-container>
        <ng-container crmLoggerContent="fields">
          <ng-container *ngTemplateOutlet="associationFormRow"></ng-container>
          <glxy-form-row class="detail-form-row" [class.mobile]="layout.mobile">
            <ng-container [ngTemplateOutlet]="addTeamMembers"></ng-container>
          </glxy-form-row>
          <glxy-form-row class="detail-form-row" [class.mobile]="layout.mobile">
            <ng-container [ngTemplateOutlet]="addOpportunities"></ng-container>
          </glxy-form-row>
          <glxy-form-row class="detail-form-row" [class.mobile]="layout.mobile">
            <ng-container [ngTemplateOutlet]="addTags"></ng-container>
          </glxy-form-row>
          <ng-container [ngTemplateOutlet]="addFollowUpTask"></ng-container>
        </ng-container>
      </crm-activity-logger-communication>

      <!-- Default state (collapsed) -->
      <form *ngSwitchDefault class="activity-content">
        <div class="content-container">
          <glxy-form-row>
            <glxy-form-field bottomSpacing="small" [showLabel]="false">
              <textarea
                matInput
                placeholder="{{ 'ACTIVITY_LOGGER.NOTE_PLACEHOLDER' | translate }}"
                [rows]="1"
                (focus)="handleDefaultStateFocus()"
              ></textarea>
            </glxy-form-field>
          </glxy-form-row>
        </div>
        <ng-container
          [ngTemplateOutlet]="activitySelector"
          [ngTemplateOutletContext]="{ noMargins: true }"
        ></ng-container>
      </form>
    </mat-card-content>
    <ng-container *ngIf="activityTypeSelected">
      <ng-container *ngTemplateOutlet="formButtons"></ng-container>
    </ng-container>
  </mat-card>

  <ng-template #avatar>
    <div class="avatar-container" [class.mobile]="layout.mobile" [class.editing]="layout.editing">
      <glxy-avatar
        matCardAvatar
        *ngIf="user$ | async as user; else unknownUserAvatar"
        [name]="user.fullName ?? ''"
        [width]="AVATAR_WIDTH"
        [src]="user.profileImageUrl || ''"
      ></glxy-avatar>
    </div>
    <ng-template #unknownUserAvatar>
      <crm-unknown-user-avatar [width]="AVATAR_WIDTH"></crm-unknown-user-avatar>
    </ng-template>
  </ng-template>
  <ng-template #activitySelector let-noMargins="noMargins">
    <div *ngIf="!layout.editing" class="activity-type-selector" [class.no-margins]="noMargins">
      <div class="inline-container">
        <crm-chip-list
          #activityTypeSelector
          [attr.aria-label]="'ACTIVITY_LOGGER.ACTIVITY_TYPE_SELECTOR_ARIA_LABEL' | translate"
          [hideLabelWhenSelected]="layout.mobile"
          [items]="SELECTABLE_ACTIVITY_TYPES"
          [selected]="activityTypeSelected"
          (selectedChange)="onActivityTypeChanged($event)"
          [size]="layout.mobile ? 'large' : 'default'"
        ></crm-chip-list>
        <!-- dropdown communication subtypes -->
        <button mat-stroked-button [matMenuTriggerFor]="communicationMenu" class="button-with-margin" type="button">
          {{ getTranslatedCommunicationType() | translate }}
          <mat-icon class="dropdown-arrow" iconPositionEnd>arrow_drop_down</mat-icon>
        </button>
        <mat-menu #communicationMenu="matMenu">
          <button
            mat-menu-item
            *ngFor="let communicationType of SELECTABLE_COMMUNICATION_TYPES"
            (click)="onCommunicationTypeChanged('Communication', communicationType.value)"
          >
            {{ communicationType.label | translate }}
          </button>
        </mat-menu>
      </div>
    </div>
  </ng-template>
  <ng-template #associationFormRow>
    <glxy-form-row *ngIf="!hideAssociations" class="detail-form-row" [class.mobile]="layout.mobile">
      <glxy-form-field
        [prefixIcon]="'person'"
        bottomSpacing="small"
        class="col detail-form-field"
        [class.mobile]="layout.mobile"
      >
        <crm-activity-logger-contact-association
          insideInputWrapper
          class="col"
          [(associations)]="contactAssociations"
          [fixedId]="crmObjectId$ | async"
          [mobile]="layout.mobile"
          [placeholder]="'ACTIVITY_LOGGER.ADD_CONTACT_ASSOCIATION' | translate"
        ></crm-activity-logger-contact-association>
      </glxy-form-field>
      <glxy-form-field
        prefixIcon="domain"
        bottomSpacing="small"
        class="col detail-form-field"
        [class.mobile]="layout.mobile"
      >
        <crm-activity-logger-company-association
          insideInputWrapper
          class="col"
          [(associations)]="companyAssociations"
          [fixedId]="crmObjectId$ | async"
          [mobile]="layout.mobile"
          [placeholder]="'ACTIVITY_LOGGER.ADD_COMPANY_ASSOCIATION' | translate"
        ></crm-activity-logger-company-association>
      </glxy-form-field>
    </glxy-form-row>
  </ng-template>
  <ng-template #formButtons>
    <mat-card-actions [align]="'start'" class="activity-form-actions" [class.editing]="layout.editing">
      <div
        class="avatar-container"
        [class.mobile]="layout.mobile"
        [class.editing]="layout.editing"
        [style.width.px]="AVATAR_WIDTH"
      ></div>
      <button
        mat-flat-button
        color="primary"
        type="button"
        (click)="upsertActivity()"
        [disabled]="upsertActivityButtonLoading$ | async"
      >
        <glxy-button-loading-indicator [isLoading]="(upsertActivityButtonLoading$ | async) === true">
          <ng-container *ngIf="layout.editing; else createActivity">
            {{ 'ACTIVITY_LOGGER.SAVE' | translate }}
          </ng-container>
          <ng-template #createActivity>
            <ng-container *ngIf="activityTypeSelected === 'Task'; else logActivity">
              {{ 'ACTIVITY_LOGGER.CREATE_TASK' | translate }}
            </ng-container>
            <ng-template #logActivity>
              {{ 'ACTIVITY_LOGGER.LOG_ACTIVITY' | translate }}
            </ng-template>
          </ng-template>
        </glxy-button-loading-indicator>
      </button>
      <button mat-stroked-button (click)="handleCancelClicked()" type="button">
        {{ 'ACTIVITY_LOGGER.CANCEL' | translate }}
      </button>
    </mat-card-actions>
  </ng-template>
  <ng-template #addTeamMembers>
    <glxy-form-field
      *ngIf="showTeamMemberInput"
      prefixIcon="group"
      bottomSpacing="small"
      class="detail-form-field"
      [class.mobile]="layout.mobile"
    >
      <crm-activity-logger-team-association
        insideInputWrapper
        class="col"
        [(associations)]="teamAssociations"
        [fixedId]="activityOwnerId$ | async"
        [mobile]="layout.mobile"
        [placeholder]="'ACTIVITY_LOGGER.ADD_TEAM_MEMBER_ASSOCIATION' | translate"
      ></crm-activity-logger-team-association>
    </glxy-form-field>
  </ng-template>
  <ng-template #addOpportunities>
    <glxy-form-field
      *ngIf="(isCompany$ | async) && showOpportunityInput && !hideAssociations"
      prefixIcon="monetization_on"
      bottomSpacing="small"
      class="detail-form-field"
      [class.mobile]="layout.mobile"
    >
      <crm-activity-logger-opportunity-association
        insideInputWrapper
        class="col"
        [accountGroupId]="primaryAccountGroupId$ | async"
        [(associations)]="opportunityAssociations"
        [mobile]="layout.mobile"
        [placeholder]="'ACTIVITY_LOGGER.ADD_OPPORTUNITY_ASSOCIATION' | translate"
      ></crm-activity-logger-opportunity-association>
    </glxy-form-field>
  </ng-template>
  <ng-template #addTags>
    <glxy-form-field
      prefixIcon="local_offer"
      bottomSpacing="small"
      class="detail-form-field"
      [class.mobile]="layout.mobile"
    >
      <crm-activity-logger-tags
        insideInputWrapper
        class="col"
        [tags]="tags$ | async"
        [mobile]="layout.mobile"
        (tagsChanged)="updateTags($event)"
      ></crm-activity-logger-tags>
    </glxy-form-field>
  </ng-template>
  <ng-template #addFollowUpTask>
    <crm-activity-logger-follow-up-task
      *ngIf="!layout.editing"
      (expandedChanged)="followUpExpandedChanged($event)"
    ></crm-activity-logger-follow-up-task>
  </ng-template>
</ng-container>
